import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

import type { QueryParams } from '@/utils/queryParams'

type UseGetInfinitePortfolioColumnProps = {
  query: QueryParams & { portfolioId: string }
}

export const useGetInfinitePortfolioColumn = ({
  query,
}: UseGetInfinitePortfolioColumnProps) => {
  const { limit = 2, page = 1, portfolioId } = query
  const { toast } = useToast()

  const {
    data,
    isError,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    refetch: refetchPortfolioColumn,
  } = useInfiniteQuery({
    queryKey: [
      'portfolioColumn',
      portfolioId,
      {
        limit,
        page,
      },
    ],
    queryFn: async ({ pageParam = page }) => {
      const response = await projectService.portfolioColumn.get({
        query: {
          portfolioId,
          limit,
          page: pageParam,
        },
      })

      return response
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.pagination.page < lastPage.pagination.pages) {
        return lastPage.pagination.page + 1
      }
      return undefined
    },
    initialPageParam: page,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar as colunas do portfólio',
        variant: 'destructive',
      })
  }, [isError, toast])

  return {
    data,
    isLoading,
    isLoadingNextPage: isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    refetchPortfolioColumn,
  }
}
